// extracted by mini-css-extract-plugin
module.exports = {"Game":"Game_Game__2qp9N","Header":"Game_Header__2ebeu","Search":"Game_Search__2L6ig","artForm":"Game_artForm__yf6YM"};